/* ==========================================================================
   LZ Finder (metaobjects) — Carte interactive des cavistes & restaurants partenaires
   Dépend de :
   - Leaflet 1.9 (chargé via CDN unpkg)
   - Leaflet.MarkerCluster 1.5 (chargé via CDN unpkg)
   - <script id="finder-data" type="application/json"> injecté par le template Liquid
   ========================================================================== */

(function () {
  function boot() {
    if (typeof L === 'undefined' || typeof L.markerClusterGroup === 'undefined') {
      setTimeout(boot, 100);
      return;
    }
    init();
  }

  function init() {
    var dataEl = document.getElementById('finder-data');
    var establishments = [];
    try {
      var txt = dataEl ? dataEl.textContent.trim() : '';
      if (txt) establishments = JSON.parse(txt);
    } catch (e) {
      console.error('[lz-finder] Erreur parsing JSON :', e);
      return;
    }
    if (!Array.isArray(establishments)) establishments = [];

    // Pages supplémentaires (paginate Liquid) récupérées via la Section Rendering API
    var pages = parseInt((dataEl && dataEl.getAttribute('data-pages')) || '1', 10) || 1;
    var sectionId = dataEl && dataEl.getAttribute('data-section');

    fetchOtherPages(pages, sectionId)
      .then(function (extra) { return geocodeMissing(establishments.concat(extra)); })
      .then(function (list) {
        if (list.length === 0) {
          console.warn('[lz-finder] Aucun établissement trouvé dans les metaobjects.');
          return;
        }
        run(list);
      });
  }

  /* Récupère les pages 2..N du JSON via /pages/xxx?section_id=...&page=N */
  function fetchOtherPages(pages, sectionId) {
    if (pages <= 1 || !sectionId) return Promise.resolve([]);
    var reqs = [];
    for (var p = 2; p <= pages; p++) {
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + p;
      reqs.push(fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.getElementById('finder-data');
          try { return el ? JSON.parse(el.textContent.trim()) : []; } catch (e) { return []; }
        })
        .catch(function (e) { console.warn('[lz-finder] page ' + p + ' non chargée', e); return []; }));
    }
    return Promise.all(reqs).then(function (arrs) { return [].concat.apply([], arrs); });
  }

  /* Géocode les fiches sans coordonnées via l'API adresse (gouv.fr), avec cache navigateur */
  function geocodeMissing(list) {
    var missing = list.filter(function (e) { return !(parseFloat(e.lat) && parseFloat(e.lng)); });
    if (missing.length === 0) return Promise.resolve(list);
    var chain = Promise.resolve();
    missing.forEach(function (e) {
      chain = chain.then(function () {
        var key = 'lz-geo:' + (e.handle || (e.nom + '|' + e.cp));
        try {
          var cached = localStorage.getItem(key);
          if (cached) { var c = JSON.parse(cached); e.lat = c.lat; e.lng = c.lng; return; }
        } catch (err) {}
        var q = [e.adresse, e.cp, e.ville].filter(Boolean).join(' ');
        var url = 'https://api-adresse.data.gouv.fr/search/?limit=1&q=' + encodeURIComponent(q) +
                  (e.cp ? '&postcode=' + encodeURIComponent(e.cp) : '');
        return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
          var f = j && j.features && j.features[0];
          if (!f) { console.warn('[lz-finder] géocodage impossible :', e.nom, q); return; }
          e.lng = f.geometry.coordinates[0];
          e.lat = f.geometry.coordinates[1];
          try { localStorage.setItem(key, JSON.stringify({ lat: e.lat, lng: e.lng })); } catch (err) {}
        }).catch(function (err) { console.warn('[lz-finder] géocodage en erreur :', e.nom, err); });
      });
    });
    return chain.then(function () {
      return list.filter(function (e) { return parseFloat(e.lat) && parseFloat(e.lng); });
    });
  }

  function run(establishments) {
    var DEPT_NAMES = {
      '01': 'Ain', '02': 'Aisne', '03': 'Allier', '04': 'Alpes-de-Haute-Provence',
      '05': 'Hautes-Alpes', '06': 'Alpes-Maritimes', '07': 'Ardèche', '08': 'Ardennes',
      '09': 'Ariège', '10': 'Aube', '11': 'Aude', '12': 'Aveyron',
      '13': 'Bouches-du-Rhône', '14': 'Calvados', '15': 'Cantal', '16': 'Charente',
      '17': 'Charente-Maritime', '18': 'Cher', '19': 'Corrèze', '2A': 'Corse-du-Sud',
      '2B': 'Haute-Corse', '21': "Côte-d'Or", '22': "Côtes-d'Armor", '23': 'Creuse',
      '24': 'Dordogne', '25': 'Doubs', '26': 'Drôme', '27': 'Eure',
      '28': 'Eure-et-Loir', '29': 'Finistère', '30': 'Gard', '31': 'Haute-Garonne',
      '32': 'Gers', '33': 'Gironde', '34': 'Hérault', '35': 'Ille-et-Vilaine',
      '36': 'Indre', '37': 'Indre-et-Loire', '38': 'Isère', '39': 'Jura',
      '40': 'Landes', '41': 'Loir-et-Cher', '42': 'Loire', '43': 'Haute-Loire',
      '44': 'Loire-Atlantique', '45': 'Loiret', '46': 'Lot', '47': 'Lot-et-Garonne',
      '48': 'Lozère', '49': 'Maine-et-Loire', '50': 'Manche', '51': 'Marne',
      '52': 'Haute-Marne', '53': 'Mayenne', '54': 'Meurthe-et-Moselle', '55': 'Meuse',
      '56': 'Morbihan', '57': 'Moselle', '58': 'Nièvre', '59': 'Nord',
      '60': 'Oise', '61': 'Orne', '62': 'Pas-de-Calais', '63': 'Puy-de-Dôme',
      '64': 'Pyrénées-Atlantiques', '65': 'Hautes-Pyrénées', '66': 'Pyrénées-Orientales',
      '67': 'Bas-Rhin', '68': 'Haut-Rhin', '69': 'Rhône', '70': 'Haute-Saône',
      '71': 'Saône-et-Loire', '72': 'Sarthe', '73': 'Savoie', '74': 'Haute-Savoie',
      '75': 'Paris', '76': 'Seine-Maritime', '77': 'Seine-et-Marne', '78': 'Yvelines',
      '79': 'Deux-Sèvres', '80': 'Somme', '81': 'Tarn', '82': 'Tarn-et-Garonne',
      '83': 'Var', '84': 'Vaucluse', '85': 'Vendée', '86': 'Vienne',
      '87': 'Haute-Vienne', '88': 'Vosges', '89': 'Yonne', '90': 'Territoire de Belfort',
      '91': 'Essonne', '92': 'Hauts-de-Seine', '93': 'Seine-Saint-Denis',
      '94': 'Val-de-Marne', '95': "Val-d'Oise"
    };

    // Stats
    var stats = {
      total: establishments.length,
      caviste: establishments.filter(function (e) { return e.type === 'caviste'; }).length,
      restaurant: establishments.filter(function (e) { return e.type === 'restaurant'; }).length,
      villes: new Set(establishments.map(function (e) { return e.cp + '|' + e.ville; })).size,
      depts: new Set(establishments.map(function (e) { return e.dept; })).size
    };
    setText('stat-cavistes', stats.caviste);
    setText('stat-restaurants', stats.restaurant);
    setText('stat-villes', stats.villes);
    setText('stat-depts', stats.depts);
    setText('count-all', '(' + stats.total + ')');
    setText('count-caviste', '(' + stats.caviste + ')');
    setText('count-restaurant', '(' + stats.restaurant + ')');

    // State doit exister avant refreshDeptSelect
    var state = { filter: 'all', search: '', dept: 'all' };

    // Remplir le select département (uniquement les départements qui ont au moins
    // un établissement du type actuellement filtré)
    var deptSelect = document.getElementById('finder-dept-select');
    function refreshDeptSelect() {
      if (!deptSelect) return;
      var currentValue = deptSelect.value;
      var relevant = establishments.filter(function (e) {
        return state.filter === 'all' || e.type === state.filter;
      });
      var depts = Array.from(new Set(relevant.map(function (e) { return e.dept; }))).sort();
      deptSelect.innerHTML = '<option value="all">Tous les départements</option>';
      depts.forEach(function (d) {
        var opt = document.createElement('option');
        opt.value = d;
        opt.textContent = d + ' — ' + (DEPT_NAMES[d] || d);
        deptSelect.appendChild(opt);
      });
      // Restaurer la sélection si elle existe toujours, sinon reset sur "all"
      if (depts.indexOf(currentValue) !== -1) {
        deptSelect.value = currentValue;
      } else {
        deptSelect.value = 'all';
        if (state) state.dept = 'all';
      }
    }
    refreshDeptSelect();

    // Leaflet map
    var map = L.map('finder-map', {
      center: [46.5, 2.5],
      zoom: 6,
      zoomControl: true,
      scrollWheelZoom: false,
      attributionControl: true
    });
    map.on('click', function () { map.scrollWheelZoom.enable(); });
    map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      className: 'lz-finder-tiles',
      maxZoom: 19
    }).addTo(map);

    // Bouton Leaflet "Réinitialiser le zoom"
    var ResetControl = L.Control.extend({
      options: { position: 'topright' },
      onAdd: function() {
        var btn = L.DomUtil.create('a', 'leaflet-bar leaflet-control lz-finder-reset');
        btn.href = '#';
        btn.title = 'Réinitialiser le zoom';
        btn.setAttribute('aria-label', 'Réinitialiser le zoom');
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/></svg>';
        L.DomEvent.on(btn, 'click', function(e) {
          L.DomEvent.preventDefault(e);
          L.DomEvent.stopPropagation(e);
          // Reset : revoir tous les établissements, recentrer
          state.filter = 'all';
          state.dept = 'all';
          state.search = '';
          var searchInputEl = document.getElementById('finder-search-input');
          if (searchInputEl) searchInputEl.value = '';
          var deptSelectEl = document.getElementById('finder-dept-select');
          if (deptSelectEl) deptSelectEl.value = 'all';
          document.querySelectorAll('.finder-filter').forEach(function(b) {
            b.classList.toggle('is-active', b.dataset.filter === 'all');
          });
          applyFilters();
        });
        return btn;
      }
    });
    map.addControl(new ResetControl());

    var iconCaviste = makeIcon('caviste');
    var iconRestaurant = makeIcon('restaurant');

    var clusters = L.markerClusterGroup({
      showCoverageOnHover: false,
      spiderfyOnMaxZoom: true,
      maxClusterRadius: 50,
      iconCreateFunction: function (cluster) {
        var count = cluster.getChildCount();
        var size = 'small';
        if (count >= 10) size = 'medium';
        if (count >= 50) size = 'large';
        return L.divIcon({
          html: '<div><span>' + count + '</span></div>',
          className: 'marker-cluster marker-cluster-' + size,
          iconSize: L.point(40, 40)
        });
      }
    });

    var allMarkers = [];
    establishments.forEach(function (e) {
      var icon = e.type === 'caviste' ? iconCaviste : iconRestaurant;
      var marker = L.marker([e.lat, e.lng], { icon: icon });
      var typeLabel = e.type === 'caviste' ? 'Caviste' : 'Restaurant';
      var typeClass = e.type === 'caviste' ? 'popup-type--caviste' : 'popup-type--restaurant';
      marker.bindPopup(
        '<div class="popup-type ' + typeClass + '"><span class="popup-type__dot"></span>' + typeLabel + '</div>' +
        '<div class="popup-name">' + escapeHtml(e.nom) + '</div>' +
        '<div class="popup-location">' + escapeHtml(e.ville) + ' · ' + e.cp + '</div>'
      );
      marker._data = e;
      marker._searchText = (e.nom + ' ' + e.ville + ' ' + e.cp + ' ' + (DEPT_NAMES[e.dept] || '')).toLowerCase();
      allMarkers.push(marker);
    });
    clusters.addLayers(allMarkers);
    map.addLayer(clusters);

    // Fit bounds initial
    if (allMarkers.length > 0) {
      var group = new L.featureGroup(allMarkers);
      map.fitBounds(group.getBounds().pad(0.1));
    }

    // Contours départementaux cliquables : survol highlight + clic scroll vers liste
    var deptsUrl = window.LZ_DEPARTEMENTS_URL || 'https://cdn.jsdelivr.net/gh/gregoiredavid/france-geojson@master/departements-version-simplifiee.geojson';
    fetch(deptsUrl)
      .then(function(r) { return r.json(); })
      .then(function(geojson) {
        var deptLayer = L.geoJSON(geojson, {
          style: {
            color: 'transparent',
            weight: 1,
            fillColor: '#a8213c',
            fillOpacity: 0
          },
          onEachFeature: function(feature, layer) {
            var deptCode = feature.properties.code;
            var deptName = feature.properties.nom;
            var count = establishments.filter(function(e) { return e.dept === deptCode; }).length;

            layer.on({
              mouseover: function(e) {
                e.target.setStyle({
                  color: '#a8213c',
                  weight: 1.5,
                  fillOpacity: 0.15
                });
              },
              mouseout: function(e) {
                deptLayer.resetStyle(e.target);
              },
              click: function() {
                scrollToDeptInList(deptCode);
              }
            });

            if (count > 0) {
              layer.bindTooltip(
                '<strong>' + deptName + '</strong> (' + deptCode + ')<br>' +
                count + ' établissement' + (count > 1 ? 's' : ''),
                { sticky: true, direction: 'top', className: 'lz-finder-tooltip' }
              );
            }
          }
        });
        deptLayer.addTo(map);
        deptLayer.bringToBack();
      })
      .catch(function(err) { console.warn('[lz-finder] GeoJSON départements non chargé :', err); });

    function scrollToDeptInList(deptCode) {
      var container = document.getElementById('finder-list-body');
      if (!container) return;
      var all = container.querySelectorAll('.finder-dept');
      var target = null;
      all.forEach(function(d) {
        var isTarget = d.dataset.dept === deptCode;
        d.classList.toggle('is-open', isTarget);
        var toggleBtn = d.querySelector('.finder-dept__toggle');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', isTarget);
        if (isTarget) target = d;
      });
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function applyFilters() {
      clusters.clearLayers();
      var q = state.search.trim().toLowerCase();
      var filtered = allMarkers.filter(function (m) {
        if (state.filter !== 'all' && m._data.type !== state.filter) return false;
        if (state.dept !== 'all' && m._data.dept !== state.dept) return false;
        if (q && m._searchText.indexOf(q) === -1) return false;
        return true;
      });
      clusters.addLayers(filtered);
      renderList(filtered.map(function (m) { return m._data; }));

      // Recadrer la carte sur les résultats filtrés
      if (filtered.length > 0) {
        var group = new L.featureGroup(filtered);
        map.fitBounds(group.getBounds().pad(0.15), { animate: true, maxZoom: 12 });
      } else {
        // Aucun résultat : retour à la vue France entière
        map.setView([46.5, 2.5], 6, { animate: true });
      }
    }

    // Filter buttons type
    document.querySelectorAll('.finder-filter').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.finder-filter').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.filter = btn.dataset.filter;
        refreshDeptSelect();
        applyFilters();
      });
    });

    // Search
    var searchInput = document.getElementById('finder-search-input');
    var searchTimer;
    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          state.search = e.target.value;
          applyFilters();
        }, 150);
      });
    }

    // Dept select
    if (deptSelect) {
      deptSelect.addEventListener('change', function (e) {
        state.dept = e.target.value;
        applyFilters();
      });
    }

    var listBody = document.getElementById('finder-list-body');

    function renderList(items) {
      if (!listBody) return;
      if (items.length === 0) {
        listBody.innerHTML = '<p class="finder-empty">Aucun établissement ne correspond à votre recherche.</p>';
        return;
      }
      var byDept = {};
      items.forEach(function (e) {
        if (!byDept[e.dept]) byDept[e.dept] = [];
        byDept[e.dept].push(e);
      });
      var sortedDepts = Object.keys(byDept).sort();
      var isFiltered = state.search || state.filter !== 'all' || state.dept !== 'all';

      listBody.innerHTML = sortedDepts.map(function (dept) {
        var list = byDept[dept].sort(function (a, b) {
          return a.ville.localeCompare(b.ville, 'fr') || a.nom.localeCompare(b.nom, 'fr');
        });
        var name = DEPT_NAMES[dept] || dept;
        var cavCount = list.filter(function (e) { return e.type === 'caviste'; }).length;
        var restCount = list.filter(function (e) { return e.type === 'restaurant'; }).length;
        var metaParts = [];
        if (cavCount) metaParts.push(cavCount + ' caviste' + (cavCount > 1 ? 's' : ''));
        if (restCount) metaParts.push(restCount + ' restaurant' + (restCount > 1 ? 's' : ''));

        return (
          '<div class="finder-dept' + (isFiltered ? ' is-open' : '') + '" data-dept="' + dept + '">' +
            '<button class="finder-dept__toggle" aria-expanded="' + isFiltered + '">' +
              '<span>' +
                '<span class="finder-dept__name">' + escapeHtml(name) + '</span>' +
                '<span class="finder-dept__code">' + dept + '</span>' +
              '</span>' +
              '<span class="finder-dept__meta">' +
                '<span>' + metaParts.join(' · ') + '</span>' +
                '<svg class="finder-dept__chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
                  '<polyline points="6 9 12 15 18 9"/>' +
                '</svg>' +
              '</span>' +
            '</button>' +
            '<div class="finder-dept__body">' +
              list.map(function (e) {
                return '<article class="finder-card finder-card--' + e.type + '" data-lat="' + e.lat + '" data-lng="' + e.lng + '">' +
                  '<span class="finder-card__type">' + (e.type === 'caviste' ? 'Caviste' : 'Restaurant') + '</span>' +
                  '<h3 class="finder-card__name">' + escapeHtml(e.nom) + '</h3>' +
                  '<p class="finder-card__ville">' + escapeHtml(e.ville) + ' · ' + e.cp + '</p>' +
                '</article>';
              }).join('') +
            '</div>' +
          '</div>'
        );
      }).join('');

      // Toggles
      listBody.querySelectorAll('.finder-dept__toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dept = btn.closest('.finder-dept');
          dept.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', dept.classList.contains('is-open'));
        });
      });

      // Card click → zoom carte
      listBody.querySelectorAll('.finder-card').forEach(function (card) {
        card.addEventListener('click', function () {
          var lat = parseFloat(card.dataset.lat);
          var lng = parseFloat(card.dataset.lng);
          map.setView([lat, lng], 15, { animate: true });
          var marker = allMarkers.find(function (m) { return m._data.lat === lat && m._data.lng === lng; });
          if (marker) setTimeout(function () { marker.openPopup(); }, 400);
          document.getElementById('finder-map').scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    }

    renderList(establishments);

    // Bouton "Retour à la carte" : visible uniquement quand la carte est hors viewport
    var backBtn = document.getElementById('finder-back-to-map');
    var mapEl = document.getElementById('finder-map');
    if (backBtn && mapEl) {
      // Déplacer le bouton vers document.body pour éviter tout ancêtre `transform`
      // qui casserait le position:fixed.
      if (backBtn.parentElement !== document.body) {
        document.body.appendChild(backBtn);
      }
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          backBtn.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      io.observe(mapEl);

      backBtn.addEventListener('click', function() {
        mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function makeIcon(type) {
    var color = type === 'caviste' ? '#a8213c' : '#6b4e3d';
    var inner = type === 'caviste'
      ? '<path d="M14 4 C 10 10, 6 14, 6 18 A 8 8 0 0 0 22 18 C 22 14, 18 10, 14 4 Z" fill="' + color + '" stroke="#fff" stroke-width="1.5"/>'
      : '<circle cx="14" cy="14" r="10" fill="' + color + '" stroke="#fff" stroke-width="1.5"/>' +
        '<path d="M11 8 V 14 M11 14 V 20 M9 8 V 12 M13 8 V 12 M17 8 V 20 M17 8 a 2 3 0 0 1 0 6" stroke="#fff" stroke-width="1.3" fill="none" stroke-linecap="round"/>';
    return L.divIcon({
      className: 'finder-marker',
      html: '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" style="filter: drop-shadow(0 2px 4px rgba(0,0,0,0.25));">' + inner + '</svg>',
      iconSize: [28, 28],
      iconAnchor: [14, 14],
      popupAnchor: [0, -14]
    });
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
